import { axiosClient } from '../../clients/axios-client'
import type { FileInfoType, FileParsingStatus } from '../../types'
import type { FilePoolUploadConfirmationResponseDto, FileUploadUrlResponseDto } from './dtos/file'
import {
  FilePoolUploadConfirmationResponseDtoSchema,
  FileUploadUrlResponseDtoSchema,
} from './dtos/file'

interface UploadUrlResponseType {
  fileId: string
  uploadUrl: string
}

export async function getUploadUrl({
  fileName,
  fileType,
  fileSize,
}: {
  fileName: string
  fileType: string
  fileSize: number
}): Promise<UploadUrlResponseType> {
  const payload = {
    filename: fileName,
    content_type: fileType,
    file_size: fileSize,
  }

  try {
    const { data } = await axiosClient.post<FileUploadUrlResponseDto>(
      '/filepool/upload-url',
      payload
    )

    const parsedData: FileUploadUrlResponseDto = FileUploadUrlResponseDtoSchema.parse(data)

    const { upload_url, file_id } = parsedData

    const response: UploadUrlResponseType = {
      fileId: file_id,
      uploadUrl: upload_url,
    }

    return response
  } catch (error) {
    console.error(`Getting pre-signed URL failed. File name: ${fileName}`, error)
    throw error
  }
}

export async function setUploadComplete({ fileId }: { fileId: string }): Promise<FileInfoType> {
  const payload = {
    file_id: fileId,
  }

  try {
    const { data } = await axiosClient.post<FilePoolUploadConfirmationResponseDto>(
      '/filepool/files/s3-complete',
      payload
    )

    const { success, file, message } = FilePoolUploadConfirmationResponseDtoSchema.parse(data)

    if (!success) {
      throw new Error(`Upload confirmation failed with the following message: ${message}`)
    }

    const response: FileInfoType = {
      id: file.file_id,
      name: file.filename,
      type: file.file_type,
      parsingStatus: file.parsing_status as FileParsingStatus,
      uploadedAt: file.uploaded_at,
      expiresAt: file.expires_at,
      isExcluded: file.is_excluded ?? false,
    }

    return response
  } catch (error) {
    console.error(`File upload confirmation failed. File id: ${fileId}`, error)
    throw error
  }
}
